module.exports = __webpack_public_path__ + "static/media/ami_pl.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_pl.png
// module id = 570
// module chunks = 1